import React from "react";
import { useOutletContext } from "react-router-dom";
import { getTutorTickets } from "../../../services/dataService";
import { TicketsCard } from "../../Students/tabs/TicketsTab";

// The tickets the tutor raised and the ones about their lessons (047 D44), in the student tab's
// card: one list, newest first, capped at 50 of each.
const TicketsTab = () => {
  const { tutor, userRole } = useOutletContext();
  return <TicketsCard uid={tutor.id} read={getTutorTickets} timeZone={tutor.timeZone} userRole={userRole} emptyText="No tickets for this tutor." />;
};

export default TicketsTab;
